// extracted by mini-css-extract-plugin
export default {"cls1":"FollowActionButton-cls1___560ad5bdc9611d36730","cls2":"FollowActionButton-cls2__c7783f04a09634896b94 FollowActionButton-cls1___560ad5bdc9611d36730"};